module.exports = __webpack_public_path__ + "img/green.bef668f9.png";